import cmp from './DeclineVerificationDialog'

export default cmp
